import { nanoid } from 'nanoid'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    items: [],
    closeTime: 5000
  }),
  actions: {
    reset () {
      this.items = []
    },
    pushNotification ({
      content,
      actionLabel = null,
      selfClosing = true
    }) {
      this.items.push({
        id: nanoid(6),
        content: content,
        actionLabel: actionLabel,
        selfClosing: selfClosing
      })
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNotificationsStore, import.meta.hot))
}
